module.exports = __webpack_public_path__ + "static/media/boom-math.1c80387d.png";